export default __webpack_public_path__ + "static/media/total-icon.8a01b621.svg";